import { Component } from 'vue-property-decorator';
import AbstractView from '@/views/abstract-view';
import DomainIndex from '@/components/domain-index/index.vue';

@Component({
    components: {
        'app-domain-index': DomainIndex,
    },
})
export default class DomainIndexView extends AbstractView
{
    protected get title(): string
    {
        return this.$t('navbar.message.domains').toString();
    }
}